// Puts a pre-rendered page's <head> back to the plain app shell before React
// mounts.
//
// scripts/prerender.js serves /, /pricing, /privacy and /terms as static HTML
// whose head carries that page's title, description, canonical and JSON-LD.
// Every edited tag is marked with data-shell-value (the shell's original
// value) and every added tag with data-page-meta. Without this reset those
// values would outlive the page: a logged-in user landing on / is redirected
// to /dashboard and LandingPage never mounts, so nothing would ever restore
// the landing title. The page that does render re-applies its own tags through
// usePageMeta immediately after.
//
// On a page that was not pre-rendered there is nothing marked, so this does
// nothing.
export function resetPrerenderedHead() {
  document.querySelectorAll('[data-shell-value]').forEach((el) => {
    const value = el.getAttribute('data-shell-value');
    if (el.tagName === 'TITLE') {
      el.textContent = value;
    } else {
      el.setAttribute(el.tagName === 'LINK' ? 'href' : 'content', value);
    }
    el.removeAttribute('data-shell-value');
  });
  document.querySelectorAll('[data-page-meta]').forEach((el) => el.remove());
}
